import {gql} from '@apollo/client';

export const BillPayerSynchronizationStatus = gql`
    fragment BillPayerSynchronizationStatus on SynchronizationStatus {
        __typename
        lastSyncTime
        ... on Synced {
            lastSyncTime
        }
        ... on Syncing {
            lastSyncTime
            syncStarted
        }
        ... on SyncError {
            lastSyncTime
            message
        }
        ... on NotSynced {
            lastSyncTime
        }
    }
`;
